<template>
  <div class="container d-flex flex-column">
    <Logged-user />
    <div v-if="loading" class="loading">
      <clip-loader />
    </div>
    <div class="row mt-4" v-else>
      <div class="col-8 col-lg-4">
        <table class="table table-stripped table-sm mt-2">
          <thead>
            <tr>
              <th>Mois</th>
              <th>Dons</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="payment in totalPerMonths" v-bind:key="payment.timestamp">
              <td>{{payment.month}}</td>
              <td class="text-end">{{payment.display}}</td>
            </tr>
            <tr>
              <td class="text-end">Total</td>
              <td class="text-end">{{total}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-12">
        <table class="table table-stripped table-sm mt-2">
          <thead>
            <tr>
              <th>#</th>
              <th>User id</th>
              <th>Date</th>
              <th>Email</th>
              <th>Montant</th>
              <th>Taxe Stripe<br/>(1,4% + 0,25€)</th>
              <th>Reste</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(payment, index) in payments" v-bind:key="payment.id">
              <td>{{index + 1}}</td>
              <td class="userid">{{payment.userId}}</td>
              <td>{{toDate(payment.paymentIntent.created * 1000)}}</td>
              <td>{{payment.email}}</td>
              <td class="text-end brut">{{payment.paymentIntent.amount / 100}} €</td>
              <td class="text-end taxes">-{{payment.taxes / 100}} €</td>
              <td class="text-end collected">{{payment.collected / 100}} €</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="mt-auto">
      <bottom-nav />
    </div>
  </div>
</template>

<script>
import LoggedUser from '../LoggedUser.vue';
import BottomNav from '../BottomNav.vue';
import ClipLoader from '../ClipLoader.vue';

const padZero = n => ((n < 10) ? `0${n}` : n);

export default {
  name: 'AdminPayments',
  components: { LoggedUser, BottomNav, ClipLoader },
  data() {
    return {
      payments: [],
      totalPerMonths: [],
      total: 0,
      loading: true,
    };
  },
  created() {
    this.getPayments().then((res) => {
      const payments = res
        .sort((a, b) => b.createdAt - a.createdAt)
        .map(payment => ({
          ...payment,
          taxes: Math.round(25 + (0.014 * payment.amount)),
          collected: Math.round(payment.amount - (25 + (0.014 * payment.amount))),
        }));
      this.payments = payments;
      const sum = payments.reduce((acc, payment) => acc + payment.collected, 0);
      this.total = (sum / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
      this.totalPerMonths = payments.reduce((acc, payment) => {
        const timestamp = payment.paymentIntent.created * 1000;
        const d = new Date(timestamp);
        const month = `${padZero(d.getMonth() + 1)}/${d.getFullYear()}`;
        const totalMonth = acc.find(t => t.month === month) ||
          {
            month,
            timestamp,
            collected: 0,
          };
        totalMonth.collected += payment.collected;
        return [].concat(acc.filter(t => t.month !== month), totalMonth);
      }, [])
        .map(payment => ({
          ...payment,
          display: (payment.collected / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }),
        }))
        .sort((a, b) => b.timestamp - a.timestamp);
      this.loading = false;
    });
  },
  methods: {
    getPayments() {
      return this.$http.get(`${import.meta.env.VITE_LCT_API_URL}/payments`)
        .then(response => response.data);
    },
    toDate(timestamp) {
      const d = new Date(timestamp);
      return `${padZero(d.getDate())}/${padZero(d.getMonth() + 1)}/${d.getFullYear()}`;
    },
  },
};
</script>

<style scoped>
.loading {
  height: 200px;
  margin-top: 30px;
}
.userid{
  font-size: 0.6rem;
}
.brut {
  color: #595959;
}
.taxes {
  color: rosybrown;
}
.collected {
  color: black;
}
</style>
